import http from '../utils/http';

const material = {
    /**
     * 分组列表
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#209
     * @param {Object} options
     * @param {String} options.fileType 素材类型
     * @returns Promise
     */
    getFileGroup(options = {}, config = {}) {
        return http.post('/fileGroup/getFileGroup', options, {
            ...config
        })
    },
    /**
     * 素材类型列表
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#209
     * @param {Object} options
     * @returns Promise
     */
    getAllFileType(options = {}, config = {}) {
        return http.post('/fileType/getAllFileType', options, {
            ...config
        })
    },

    /**
     * 素材列表
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#209
     * @param {Object} options
     * @returns Promise
     */
    getFileByPage(options = {}, config = {}) {
        return http.post('/file/getFileByPage', options, {
            ...config
        })
    },

    /**
     * 添加素材分组
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#209
     * @param {Object} options
     * @returns Promise
     */
    addFileGroup(options = {}, config = {}) {
        return http.post('/fileGroup/addFileGroup', options, {
            ...config
        })
    },

    /**
     * 素材分组重命名
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#209
     * @param {Object} options
     * @returns Promise
     */
    editFileGroup(options = {}, config = {}) {
        return http.post('/fileGroup/editFileGroup', options, {
            ...config
        })
    },

    /**
     * 素材分组删除
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#209
     * @param {Object} options
     * @returns Promise
     */
    deletebyFileGroupIds(options = {}, config = {}) {
        return http.post('/fileGroup/deletebyFileGroupIds', options, {
            ...config
        })
    },

    /**
     * 素材重命名
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#209
     * @param {Object} options
     * @returns Promise
     */
    updateFileNameById(options = {}, config = {}) {
        return http.post('/file/updateFileNameById', options, {
            ...config
        })
    },

    /**
     * 素材移动分组
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#209
     * @param {Object} options
     * @returns Promise
     */
    updateFileGroupById(options = {}, config = {}) {
        return http.post('/file/updateFileGroupById', options, {
            ...config
        })
    },

    /**
     * 素材删除
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#209
     * @param {Object} options
     * @returns Promise
     */
    deleteFileById(options = {}, config = {}) {
        return http.post('/file/deleteFileById', options, {
            ...config
        })
    },

    /**
     * 素材上传
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#209
     * @param {Object} options
     * @returns Promise
     */
    uploadSure(options = {}, config = {}) {
        return http.post('/file/uploadSure', options, {
            successMsg: true,
            ...config
        })
    },

    /**
     * 素材-获取web的title
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#218
     * @param {Object} options
     * @returns Promise
    */
    getTitleByUrl(url, config = {}) {
        return http.post('/file/getTitleByUrl', {
            url
        }, {
                showLoading: '获取网页标题中...',
                ...config,
            })
    }
}

export default material;
